import React, { useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { Button, ButtonGroup, Dropdown, DropdownButton, Modal } from "react-bootstrap";

import { Common, RevokeInviteById, SUCCESS } from "../../../../helper";
import { EditInvite } from "./";
import * as commonApi from "../../../../api/commonApi";
import { errorMsg, success } from "../../../Shared";

import "../../../../assets/stlyes/Modals.css";

const InviteDropDown = (props) => {
  const { userId, getData, email } = props;
  const [editInvite, setEditInvite] = useState(false);
  const [isUserId, setIsUserId] = useState("");
  const MySwal = withReactContent(Swal);

  const revokeInvite = () => {
    MySwal.fire({
      title: Common.Revoke,
      text: RevokeInviteById(email),
      type: "success",
      showCancelButton: true,
      confirmButtonText: Common.Revoke
    }).then((result) => {
      if (result.value) {
        confirmRevoke();
      } else {
        errorMsg(Common.InvitationNotCancel)
      }
    });
  };

  const confirmRevoke = async () => {
    const revokeInvite = await commonApi.revokeInvite({
      id: userId,
    });
    if (revokeInvite.Items===SUCCESS.USER_DELETED) {
      success(SUCCESS.INVITATION_DELETED)
      getData();
    }
  };

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        id="dropdown-variants-Secondary"
        title={"Action"}
      >
        <Button
          onClick={() => {
            setIsUserId(userId);
            setEditInvite(true);
          }}
          className="modal-button d-flex justify-content-start"
        >
          <ModeEditOutlineOutlinedIcon />&nbsp;{ Common.Edit }
        </Button>
        <Dropdown.Divider />
        <Button onClick={revokeInvite} className="modal-button-danger d-flex justify-content-start">
          <RemoveCircleOutlineOutlinedIcon />&nbsp;{ Common.Revoke }
        </Button>
      </DropdownButton>

      {/* Modal For Edit invite */}
      <Modal
        show={editInvite}
        onHide={() => {
          setEditInvite(false);
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title> {Common.UpdateInvite}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditInvite
            isUserId={isUserId}
            userId={userId}
            setEditInvite={setEditInvite}
            getData={getData}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  )
}

export { InviteDropDown };
